import type { PayloadAction } from '@reduxjs/toolkit'
import type { Keys, NonCollapsableWithPrimitive } from 'common/types'

import type { RequestTypes } from '../middleware'
import type { Hubs, HubUrls } from './constants'
import { SignalRUrls } from './constants'

type SignalRActionType = 'startConnecting' | NonCollapsableWithPrimitive<string>

export function getAction<T extends Record<string, unknown[]>>(
  actionName: SignalRActionType,
  hub: Hubs,
  request: RequestTypes = 'unknown',
  methodName?: Keys<T>,
): (...data: T[Keys<T>]) => SignalRAction<T> {
  const url = SignalRUrls[hub]
  return (...data) => ({
    type: `signalR/${actionName}`,
    payload: {
      data,
      url,
      hub,
      request,
      methodName,
    },
  })
}

export type SignalRAction<T extends Record<string, unknown[]>> = PayloadAction<
  SignalRPayload<T>,
  `signalR/${SignalRActionType}`
>

type SignalRPayload<T extends Record<string, unknown[]>> = {
  data: T[Keys<T>]
  url: HubUrls
  hub: Hubs
  request: RequestTypes
  methodName?: Keys<T>
}
